export default "__VITE_ASSET__Bi3sITs5__"